import React, { Component } from 'react';
import Paper from 'material-ui/Paper';
import { withStyles } from 'material-ui/styles';
import { connect } from 'react-redux';
import { reduxForm, Form, Field } from 'redux-form';

import Button from 'material-ui/Button';
import { Grid } from '@material-ui/core';
import Card, { CardContent } from 'material-ui/Card';

import Close from 'material-ui-icons/Cancel';
import IconButton from 'material-ui/IconButton';

import ReactDropzone from 'react-dropzone';
import { MenuItem } from 'material-ui/Menu';

import RenderDialog from '../../helpers/RenderDialog';
import renderSelectField from '../../helpers/RenderSelectField';
import renderTextField from '../../helpers/RenderTextFiledWithDiv';
import upload from '../../images/upload.png';
import validationHelper from '../../helpers/ValidationHelper';
import getEnvironmentFromUrl from '../../helpers/GetEnvironment';

import postPresignedUrl from '../../actions/postPresignedUrl';
import searchByAttribute from '../../actions/searchByAttribute';
import optional from '../../helpers/OptionalAccess';
import renderCheckBoxItem from '../../helpers/RenderCheckBoxItem';

const styles = ({
  paperStyle: {
    width: '70%',
    height: '70%',
    display: 'inline-block',
    marginTop: '5.4vh',
    maxWidth: '1075px',
    //height: '650px',
    padding: '0px 30px 0px 30px'
  },
  card: {
    display: 'flex',
    boxShadow: 'none',
    height: '630px'
  },
  formDiv: {
    paddingTop: '7%'
  },
  dropBoxArea: {
    display: 'flex',
    margin: '0 auto',
    flexDirection: 'column',
    justifyContent: 'space-evenly'
  },
  availableReportDiv: {
    textAlign: 'center',
    margin: 'auto',
    color: 'grey',
    paddingTop: '10px'
  },
  dropBoxMessage: {
    fontSize: '18pt'
  },
  dropBoxMessageSpan: {
    color: '#002053',
    cursor: 'pointer'
  },
  selectionInterface: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column'
  },
  textField: {
    width: 200,
  },
  checkbox: {
    marginLeft: '0 !important',
    textAlign: 'left',
},
  formControl: {
    minWidth: 120,
  },
  backButton: {
    textAlign: 'left'
  }
});

const validate = (values) => {
  const fieldsToValidate = ['scoreModel', 'nameInput'];

  const errors = validationHelper.validateRequired(fieldsToValidate, values);
  return errors;
};

class DataTestSubmission extends Component {
  constructor(props) {
    super(props);

    this.state = {
      fileAttached: false,
      filesToUpload: [],
      fileUploadedMessage: '',
      dialogMessage: '',
      openDialog: false,
      scoreModel: '',
      customerName: '',
      invalid: true,
      fetching: false,
      allCoverage: false,
      physicalDamage: false,
    }
  }

componentDidMount() {
    this.props.actions.getPageData(this.props.data.config, this);
  }

  onDrop = (acceptedFiles) => {
    const fileName = acceptedFiles[0].name;

    const fileExt = fileName.substr(fileName.length - 4, 4);
    if (fileExt.toLowerCase() !== '.csv' && fileExt.toLowerCase() !== '.txt') {
      this.setState({
        fileUploadedMessage: '',
        fileAttached: false,
        openDialog: true,
        dialogMessage: 'The file uploaded isn\'t valid for submission.  Please make sure the file type is either .csv or .txt, then try again.' })
    } else {
      this.handleFormatCheck(acceptedFiles);
    }
  }

  handleSubmission = (e) => {
    e.preventDefault();
    const { person, autotecId, customerInfo } = this.props.data;
    const { filesToUpload, customerName, scoreModel, allCoverage, physicalDamage} = this.state;

    this.renameFile(filesToUpload[0]);

    const params = {
      key: `submissions/${person.personId}/${filesToUpload[0].name}`,
      bucket: `autotec-${getEnvironmentFromUrl()}-data-test-tool-import`,
      method: 'POST',
      fields: {
        'x-amz-meta-person_id': person.personId,
        'x-amz-meta-person_name': `${person.firstName} ${person.lastName}`,
        'x-amz-meta-customer_id': customerInfo.customerId,
        'x-amz-meta-customer_name': customerName,
        'x-amz-meta-location_id': localStorage.getItem('locationId'),
        'x-amz-meta-autotec_id': autotecId[0].autotecId,
        'x-amz-meta-score_model': scoreModel,
        'x-amz-meta-all_coverage': allCoverage.toString(),
        'x-amz-meta-physical_damage': physicalDamage.toString()
      }
    };

    this.props.actions.postPresignedUrl(this.state.filesToUpload, params, this.props.data.config, this);
  }

  handleFormatCheck = (acceptedFiles) => {
    const reader = new FileReader();

    reader.onload = () => {
      if (reader.result.trim().split(new RegExp('[,\n]'))[0].toLowerCase().trim() !== 'vin') {
        this.setState({
          fileUploadedMessage: '',
          fileAttached: false,
          openDialog: true,
          dialogMessage: 'The uploaded file must contain a column header called VIN.' });
      } else if ((reader.result.trim().split(new RegExp('[,\n]'))[1].toLowerCase().trim() !== 'effectivedate')
           && (reader.result.trim().split(new RegExp('[,\n]'))[3].toLowerCase().trim() !== 'xamend')) {
        this.setState({
          fileUploadedMessage: '',
          fileAttached: false,
          openDialog: true,
          dialogMessage: 'The uploaded file must contain a column header called EFFECTIVEDATE/XAMEND.'
        });
      } else {
          this.setState({
            fileAttached: true,
            dialogMessage: '',
            filesToUpload: acceptedFiles,
            fileUploadedMessage: (<p style={{ marginBottom: '5%' }}>Your file is ready for upload.</p>)
          });
      }
    };

    acceptedFiles.forEach(file => reader.readAsBinaryString(file));
  }

  renameFile = (filesToUpload) => {
    const { scoreModel, customerName } = this.state;
    const date = Date.now();

    const fileName = customerName.replace(/[^\w.-]/g, '')
      .concat(`_${scoreModel}_`)
      .concat(date)
      .toUpperCase();

    Object.defineProperty(filesToUpload, 'name', { writeable: true, value: fileName });
  }

  handleCloseDialog = () => {
    this.setState({ openDialog: false });

    this.props.handleRedirect();
  }

  handleScoreModelChange = (event) => {
    if (event.target.value === 'Default') {
      event.target.value = 'DT';
    }
    this.setState({ scoreModel: event.target.value });
  }

  handleCustomerNameInput = (event) => {
    this.setState({ customerName: event.target.value });
  }

  handleAllCoverageCheckboxCheckChange = (event) => {
      this.setState({allCoverage: event.target.checked});
  }

  handlePhysicalDamageCheckboxCheckChange = (event) => {
    this.setState({physicalDamage: event.target.checked});
  }


render() {
    console.log(this.state.scoreModel);
    const { classes, valid } = this.props;
    const { fileAttached,
            fileUploadedMessage,
            openDialog,
            dialogMessage
          } = this.state;

    const fileUploadType = (
      <p style={{ color: 'rgba(168, 169, 174, 1)' }}>Valid file types: csv or txt.</p>
    );

    let dialog = <div />;
    if (dialogMessage !== '') {
      dialog = (
        <RenderDialog
          open={openDialog}
          confirmButton
          message={dialogMessage}
          onClose={this.handleCloseDialog}
        />
      );
    }

    const scoreModels = ['Default', 'AZ', 'CA', 'CO', 'CT', 'FL', 'NM', 'SC'];
    const scoreModelList = scoreModels.map(model =>
        <MenuItem value={model} key={model}>{model}</MenuItem>);

    return (
      <Paper className={classes.paperStyle}>
        <Form key="DataTestFileSubmission" onSubmit={this.handleSubmission}>
          <IconButton title="close" onClick={e => this.props.handleRedirect()} style={{ float:'right', paddingTop:'3%' }}>
            <Close color="disabled" />
          </IconButton>
          <Card className={classes.card}>
            <Grid className={classes.formDiv} container alignItems="center" justify="center">
              <Grid item md={12} lg={6} sm={12} xs={12}>
                <CardContent className={classes.dropBoxArea}>
                  <ReactDropzone className="dropzone" onDrop={this.onDrop} >
                    <div className={classes.availableReportDiv}>
                      <img src={upload} alt="File Upload" width={100} height={67} />
                      <br />
                      <p className={classes.dropBoxMessage}>Drag file here or <span className={classes.dropBoxMessageSpan}>Browse</span></p>
                    </div>
                  </ReactDropzone>
                  <div style={{ height: '16px' }} className="fileUploadMsg">
                    { fileAttached ? fileUploadedMessage : fileUploadType }
                  </div>
                </CardContent>
              </Grid>
              {dialog}
              <Grid item md={12} lg={6} sm={12} xs={12}>
                <CardContent className={classes.selectionInterface}>
                  <Field
                    name="nameInput"
                    component={renderTextField}
                    onChange={this.handleCustomerNameInput}
                    placeholder="Customer"
                    className={classes.textField}
                    divClassName={classes.formControl}
                    required
                  />
                  <Field
                    component={renderSelectField}
                    name="scoreModel"
                    onChange={this.handleScoreModelChange}
                    className={classes.textField}
                    divClassName={classes.formControl}
                    children={scoreModelList}
                    label="Score Model"
                    required
                  />
                  <div>
                  <Field
                      name="allCoverage"
                      component={renderCheckBoxItem}
                      checked={this.state.allCoverage}
                      option={{id: '1', label:'All Coverage Score'}}
                      className={classes.checkbox}
                      divClassName={classes.formControl}
                      label="All Coverage Score"
                      handleCheckChange={e => this.handleAllCoverageCheckboxCheckChange(e)}
                  />
                  <Field
                      name="physicalDamage"
                      component={renderCheckBoxItem}
                      checked={this.state.physicalDamage}
                      option={{id: '2', label:'Physical Damage Score'}}
                      className={classes.checkbox}
                      divClassName={classes.formControl}
                      label="Physical Damage Score"
                      handleCheckChange={e => this.handlePhysicalDamageCheckboxCheckChange(e)}
                  />
                  </div>
                </CardContent>
              </Grid>
              <Grid item lg={12} md={12} sm={12} xs={12}>
                  <div className={classes.buttonStyle}>
                    <Button
                      variant="raised"
                      disable={!this.state.fileAttached || !valid}
                      style={valid && this.state.fileAttached ? { background: '#002053', cursor: 'pointer' } : { background: '#ddd' }}
                      type="submit"
                    >
                      Submit
                    </Button>
                  </div>
              </Grid>
            </Grid>
          </Card>
        </Form>
      </Paper>
    );
  }
}

const mapStateToProps = state => ({
  data: {
    config: state.config.config,
    person: state.person.person,
    customerInfo: state.search && state.search.customers && state.search.customers.data[0],
    autotecId: state.person.person.locations.filter(loc => loc.locationId === localStorage.locationId),
  }
});

const mapDispatchToProps = dispatch => ({
  actions: {
    getPageData: async (config, self) => {
      self.setState({ fetching: true });

      const locationId = localStorage.getItem('locationId');
      const locationResult = await dispatch(searchByAttribute('locations', 0, 'locationId', locationId, config));
      const location = optional(locationResult, ['value', 'data', 'items', 0], undefined);

      const { customerId } = location;
      const customerResult = await dispatch(searchByAttribute('customers', 0, 'customerId', customerId, config));
      const customer = optional(customerResult, ['value', 'data', 'items', 0], undefined);

      self.setState({
        customer: customer,
        fetching: false
      });
    },
    postPresignedUrl: (acceptedFiles, params, config, self) => {
      self.setState({ fetching: true });
      dispatch(postPresignedUrl(acceptedFiles, params, config)).then((res) => {
        console.log(res);
        self.setState({ openDialog: true, fileAttached: false, fetching: false, dialogMessage: 'The file has been successfully uploaded.'});
      }).catch((error) => {
        console.log(error);
        self.setState({ openDialog: true, fileAttached: false, fetching: false, dialogMessage: 'There was an error uploading the file.  Please try again.' });
      });
    }
  }
});

const ReduxForm = withStyles(styles, { withTheme: true })(reduxForm({
  form: 'DataTestFileSubmission',
  enableReinitialize: true,
  validate
})(DataTestSubmission));

const ConnectedDataTestSubmission = connect(
  mapStateToProps,
  mapDispatchToProps
)(ReduxForm);

export default ConnectedDataTestSubmission;


// WEBPACK FOOTER //
// ./src/components/Account/DataTestSubmission.js